export default {
	"exchange.GetTheVerificationCode": "获取验证码",
	"exchange.Resend": "重新发送",
	"exchange.PleaseEnterYourPhoneNumber": "请输入手机号",
	"exchange.PleaseEnterTheCorrectMobilePhoneNumber": "请输入正确的手机号",
	"exchange.please": "请",
	"exchange.sResendAfterThat": "s之后再重新发送",
	"exchange.FailedToGetVerificationCode": "获取验证码失败",
	"exchange.TheVerificationCodeIsNotLegitimate": "验证码不合法",
	"exchange.TheVerificationCodeIsIncorrect": "验证码错误",
	"exchange.ThereAreNoRedeemableItemsForThisMobilePhoneNumber": "该手机号没有可兑换的商品",
	"exchange.VerificationCode": "验证码",
	"exchange.RedeemNow": "立即兑换",
	"exchange.SelectRedeemProducts": "选择兑换商品"
}